import { CALL_API } from '../../util/RBRestMiddleware'
import Config from '../../Config'

export const FAQ_LOADING = 'FAQ_LOADING'
export const FAQ_SUCCESS = 'FAQ_SUCCESS'
export const FAQ_FAILED = 'FAQ_FAILED'

export const fetchFAQs = (lang) => {
  const language = lang === 'en-ca'
  const wl = Config.wlKey
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/faqs/all?isEnglish=${language}&wlKey=${wl}`,
        prefix: 'FAQ'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/faqActions.js